import { request, METHOD } from '../utils/request.js'

// 个人项目成绩趋势
export function scoreWithOneNewFitness(data) {
  return request(
    'h5Mfitness/newH5Fitness/scoreWithOneNewFitness',
    METHOD.POST,
    data
  )
}